import { PROTOCOL } from "@/base/base.constants";

export const MONOLITH_HOST = process?.env?.[
  "NEXT_PUBLIC_MONOLITH_HOST"
] as string;
export const MONOLITH_DOMAIN = process?.env?.[
  "NEXT_PUBLIC_ROOT_DOMAIN"
] as string;

export const MONOLITH_ORIGIN = `${PROTOCOL}://${MONOLITH_HOST}`;
export const MONOLITH_ROOT = `${PROTOCOL}://${MONOLITH_DOMAIN}`;
